import React from 'react';

export const ScriptContent = () => (
  <>
    <h3>Policy Information</h3>
    <p>
      We are also required to provide you with certain information about us and
      your rights under the contract. This will take 5-7 minutes for me to read
      out OR you can choose to read in your own time with your policy
      documentation, which would you prefer?
    </p>
    <p>Yes - refer to the DMD Full Version in the Agent Scripting Document</p>
  </>
);
